import { integrationApi } from ".";
import { Configuration } from "@/config";
import {
  PageRequest,
  PagedResponse,
} from "@/api/types";

const {
  config: { PCS_SOFTWARE_CUSTOMER_ID },
} = new Configuration();

const customerHeader = () => ({
  headers: { "Customer-Id": PCS_SOFTWARE_CUSTOMER_ID.toString() },
});

// ── OCR Feedback (DocumentClassificationFeedback) ──

export interface DocumentClassificationFeedbackDto {
  id: number;
  classificationJobId: string;
  feedbackRequest: string;
  feedbackResponse: string;
  success: boolean;
  error: string;
  isActive: boolean;
  createdById: number;
  createdAtUtc: string;
  updatedById: number;
  updatedAtUtc: string;
  // Enriched from DocumentClassificationRequest via view
  customerId: number | null;
  provider: string | null;
  fileName: string | null;
  internalFileId: string | null;
}

export const listOcrFeedback = async (request: PageRequest) => {
  const response = await integrationApi.post<
    PagedResponse<DocumentClassificationFeedbackDto>
  >(
    "v1/documentClassification/feedback/list",
    request,
    customerHeader()
  );
  return response?.data;
};

export const reviewOcrFeedback = async (id: number) => {
  await integrationApi.post(
    `v1/documentClassification/feedback/review/${id}`,
    {},
    customerHeader()
  );
};

// ── NLP Feedback (NlqGenerationFeedback) ──

export interface NlqGenerationFeedbackDto {
  id: number;
  customerId: number;
  feedbackObjectTypeId: number;
  naturalInput: string;
  instanceName: string;
  promptVersion: string | null;
  llmModel: string | null;
  generationResult: string | null;
  bindParams: string | null;
  isValid: boolean;
  isSafe: boolean | null;
  fallbackReason: string | null;
  feedback: string | null;
  feedbackType: string;
  genLatencyMs: number | null;
  execLatencyMs: number | null;
  execStatus: string | null;
  userFeedbackScore: number | null;
  userFeedbackReasonCodes: number | null;
  isActive: boolean;
  createdById: number;
  createdAtUtc: string;
  updatedById: number;
  updatedAtUtc: string;
}

export const listNlpFeedback = async (request: PageRequest) => {
  const response = await integrationApi.post<
    PagedResponse<NlqGenerationFeedbackDto>
  >(
    "v1/nlq/feedback/list",
    request,
    customerHeader()
  );
  return response?.data;
};
